<template>
  <div class="area-title-form-container">
    <el-form
      ref="ruleFormRef"
      :model="configDataForm"
      :rules="rules"
      label-width="180px"
      :size="formSize"
    >
      <el-form-item label="标题：" prop="title">
        <el-input v-model="configDataForm.title" />
      </el-form-item>
      <!-- <el-form-item label="描述：" prop="description">
        <el-input v-model="configDataForm.description"  />
      </el-form-item> -->
      <el-form-item label="区域图标：" prop="iconNameObj">
        <zc-upload
          v-model="configDataForm.iconNameObj"
          :limit-single-size="1048576"
          type="singleImage"
          :show-no-image="true"
          :small-text="true"
          :enable-popup="false"
          tip="说明：上传的图片大小不得超过100KB，建议尺寸40*40px"
          @change="handleChange(index)"
        >
          <template #singleImageError>
            <div class="el-image__error image-error-show">图片丢失</div>
          </template>
        </zc-upload>
      </el-form-item>
      <el-form-item label="区域背景色：" prop="backgroundColor">
        <el-color-picker v-model="configDataForm.backgroundColor" />
      </el-form-item>
    </el-form>
    <div class="area-title-btn-container">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleSave(ruleFormRef)"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script setup>
// #region 引用
import { verifyCharacterLength } from '@/utils/common/form-verify-util';

// #endregion

// #region props/emit

/**
 * 属性
 */
const props = defineProps({
  componentData: {
    type: Object,
    default() {},
  },
});
/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'update:modelValue',
  'handle-edit-components-content',
]);

// #endregion

// #region 变量/常量

// 栏目数据列表
// 表单size
const formSize = ref('default');
const ruleFormRef = ref();

// 表单绑定对象
const configDataForm = ref({
  title: '示例标题',
  description: '示例描述',
  backgroundImageName: '示例图片.jpg',
  backgroundImageFileKey: 'backGroundImage',
  backGroundImageObj: null,
  iconName: '示例图标1.jpg',
  iconNameObj: null,
  iconFileKey: 'iconImage',
  textColor: '#ffffff',
  backgroundColor: '#ffffff',
});
if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);

  configDataForm.value.iconNameObj = {
    name: configDataForm.value.iconName,
    url: configDataForm.value.iconFullUrl,
  };

  configDataForm.value.backGroundImageObj = {
    name: configDataForm.value.backgroundImageName,
    url: configDataForm.value.backgroundImageFullUrl,
  };
}
// 表单规则
const rules = ref({
  iconNameObj: [{ required: true, message: '必填项', trigger: 'blur' }],
  backGroundImageObj: [{ required: true, message: '必填项', trigger: 'blur' }],
  backgroundColor: [{ required: true, message: '必填项', trigger: 'blur' }],
  title: [
    { required: true, message: '必填项', trigger: 'blur' },
    { validator: verifyCharacterLength, clen: 50, trigger: 'blur' },
  ],
  description: [
    { required: true, message: '必填项', trigger: 'blur' },
    { validator: verifyCharacterLength, clen: 200, trigger: 'blur' },
  ],
});
// #endregion

// #region 生命周期

// #endregion

/**
 * 图标图片改变后调用
 */
const handleChange = (file) => {
  ruleFormRef.value.validateField('iconNameObj', (valid) => {});
};

/**
 * 背景图片改变后调用
 */
const handleBackgroundImageChange = (file) => {
  ruleFormRef.value.validateField('backGroundImageObj', (valid) => {});
};

// #region 业务方法
/**
 * 处理取消
 */
const handleCancel = () => {
  emits('handle-show-edit-form', false);
};
/**
 * 处理保存
 */
const handleSave = (form) => {
  if (!form) return;

  form.validate((valid, fields) => {
    if (valid) {
      // 待数据更新完成后才执行
      nextTick(() => {
        emits('handle-edit-components-content', false);
        emits('update:modelValue', configDataForm.value);
      });
    }
  });
};
// #endregion
</script>

<style scoped lang="scss">
.area-title-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  padding: 20px 0;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.area-title-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  background: var(--el-color-white);
}

.area-title-btn-container button {
  margin: 8px;
}

:deep(.el-color-picker__trigger) {
  width: 100px;
}

:deep(.el-form) {
  width: 100%;
  padding: 20px;
}
</style>
